var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphoneIphoneSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.584,512H153.416c-21.864-0.064-39.568-17.768-39.632-39.632V39.632C113.848,17.768,131.552,0.064,153.416,0h205.168 c21.864,0.064,39.568,17.768,39.632,39.632v432.736C398.144,494.224,380.44,511.928,358.584,512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.544,
    y: 40.4,
    style: {
      fill: "#CCCCCC"
    },
    width: 246.912,
    height: 403.76
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M293.032,24.424h-50.528c-2.28-0.008-4.12-1.848-4.128-4.128l0,0c0.008-2.28,1.848-4.12,4.128-4.128 h50.528c2.28,0.008,4.12,1.848,4.128,4.128l0,0C297.152,22.576,295.312,24.416,293.032,24.424z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CCCCCC"
    },
    cx: 218.968,
    cy: 20.296,
    r: 4.128
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M256,497.568c-10.784,0-19.52-8.736-19.52-19.52s8.736-19.52,19.52-19.52 c10.784,0,19.52,8.736,19.52,19.52l0,0C275.504,488.824,266.776,497.552,256,497.568z M256,462.52 c-8.568,0-15.52,6.952-15.52,15.52s6.952,15.52,15.52,15.52s15.52-6.952,15.52-15.52l0,0 C271.512,469.472,264.568,462.528,256,462.52z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 150.152,
    y: 86.664,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.384,
    y: 86.664,
    style: {
      fill: "#FFFFFF"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.64,
    y: 86.664,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 321.84,
    y: 86.664,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("rect", {
    x: 150.152,
    y: 151.768,
    style: {
      fill: "#FFFFFF"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.384,
    y: 151.768,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 264.64,
    y: 151.768,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("rect", {
    x: 321.84,
    y: 151.768,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150.152,
    y: 216.88,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 207.384,
    y: 216.88,
    style: {
      fill: "#FFFFFF"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.64,
    y: 216.88,
    style: {
      fill: "#FFFFFF"
    },
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.84,
    y: 216.88,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.152,
    y: 282,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.384,
    y: 282,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 264.64,
    y: 282,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.84,
    y: 282,
    style: {
      fill: "#FFFFFF"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.152,
    y: 347.04,
    style: {
      fill: "#FFFFFF"
    },
    width: 40,
    height: 40
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 207.384,
    y: 347.04,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.64,
    y: 347.04,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.84,
    y: 347.04,
    style: {
      fill: "#E21B1B"
    },
    width: 40,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneIphoneSvgrepoCom);
export default __webpack_public_path__ + "static/media/smartphone-iphone-svgrepo-com.890a788a85e534e501caa251cf1ca381.svg";
export { ForwardRef as ReactComponent };